import 'typeface-open-sans';
import 'balloon-css';
import 'react-phone-number-input/style.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faGit, faGithub, faWindows } from '@fortawesome/free-brands-svg-icons';
library.add(fas);
library.add(faGithub);
library.add(faGit);
library.add(faWindows);
